import { Divider, List } from "@mui/material";
import { useMemo } from "react";
import { CheckboxListInner, CheckboxListInnerProps } from "./CheckboxListInner";
import { CheckboxListItem, CheckboxItem } from "./CheckBoxListItem";

type CheckboxListProps = CheckboxListInnerProps & {
    emptyLabel?: string;
};

export const CheckboxList = (props: CheckboxListProps) => {
    const { emptyLabel, items, selectedValues, onChange } = props;

    const emptyItem = useMemo<CheckboxItem>(() => {
        const label = emptyLabel || "Anything";
        return {
            label,
            value: label,
        };
    }, [props.emptyLabel]);

    return (
        <List>
            {emptyLabel && (
                <>
                    <CheckboxListItem
                        checked={selectedValues.length === 0}
                        onToggle={() => onChange([])}
                        item={emptyItem}
                    />
                    <Divider />
                </>
            )}

            <CheckboxListInner items={items} selectedValues={selectedValues} onChange={onChange} />
        </List>
    );
};
